import { useEffect, useMemo, type ReactNode } from "react";
import AnalyticsContext from "./AnalyticsContext";
import createAnalyticsTransport from "../services/createAnalyticsTransport";
import storeAnalyticsMetadataInCookie from "../services/storeAnalyticsMetadataInCookie";
import ROUTES from "~/kernel/routing/ROUTES";
import isBrowser from "~/kernel/browser/isBrowser";

type AnalyticsProviderProps = {
  children: ReactNode;
};

export default function AnalyticsProvider({
  children,
}: AnalyticsProviderProps) {
  const analytics = useMemo(() => {
    if (!isBrowser()) {
      return { track: () => undefined };
    }

    return createAnalyticsTransport({
      endpoint: ROUTES.analyticsEvents.path(),
    });
  }, []);

  useEffect(() => {
    storeAnalyticsMetadataInCookie();
  }, []);

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
}
